<template>
  <div class="jumbotron d-flex align-items-center">
    <h1>PASR Analysis Guidance</h1>
  </div>
</template>

<script>
export default {
  name: 'Head',
}
</script>

<style>

</style>
